<template>
  <div class="table-responsive-md table-responsive-sm">
    <h5>آخرین خرید ها</h5>
    <table class="table text-center table-striped">
      <thead>
      <tr>
        <th scope="col">تاریخ خرید</th>
        <th scope="col">تعداد</th>
        <th scope="col">مبلغ سفارش</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="orders.length>0">
        <tr v-for="order in orders">
          <td><span dir="ltr">{{ dateConverter(order['date'], '/', true) }}</span></td>
          <td>{{ order['quantity'] }}</td>
          <td>{{ formatNumber(order['total_price']) }}</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td class="text-center" colspan="3">موردی یافت نشد</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "LatestOrderOfProduct1",
  props: {
    product: {}
  },
  data() {
    return {
      orders: []
    }
  },
  methods: {
    formatNumber,
    dateConverter,
    async getData() {
      let req = await axios.get(`show-latest-purchase/${this.product.id}`)
      this.orders = req.data.data
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>

</style>